"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TimePart_1 = require("./TimePart");
exports.TIME_PART = TimePart_1.TIME_PART;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-dateinputs@3.18.0_@progress+kendo-react-intl@3.18.0_react-dom@16.14.0_r_2yelhkp6sdgaltctm3m4k3bqy4/~/@progress/kendo-react-dateinputs/dist/npm/timepicker/models/index.js
// module id = 6523
// module chunks = 0